import { useMemo } from 'react'
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react'
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui'
import { PhantomWalletAdapter, SolflareWalletAdapter } from '@solana/wallet-adapter-wallets'
import { IS_RPC_CONFIGURED, RPC_ENDPOINT } from '@/lib/solana'

import '@solana/wallet-adapter-react-ui/styles.css'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Connection = ConnectionProvider as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Wallet = WalletProvider as any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Modal = WalletModalProvider as any

export function SolanaWalletProvider({ children }: { children: React.ReactNode }) {
  const wallets = useMemo(() => [
    new PhantomWalletAdapter(),
    new SolflareWalletAdapter(),
  ], [])

  if (!IS_RPC_CONFIGURED) {
    return <>{children}</>
  }

  return (
    <Connection endpoint={RPC_ENDPOINT}>
      <Wallet wallets={wallets} autoConnect>
        <Modal>
          {children}
        </Modal>
      </Wallet>
    </Connection>
  )
}
